import React, { useEffect, useState } from "react";
import { Modal, Row, Col, Input, Alert } from "antd";
import { SearchOutlined, LoadingOutlined } from "@ant-design/icons";
import InfiniteScroll from "react-infinite-scroll-component";
import AllGigsFilter from "../../pages/SearchSkillListing/components/AllGigs/AllGigsFilter";
import ChooseGigsButton from "../PlaceBidModal/ChooseGigsButton";
import JobCard from "../JobCard/JobCard";
import { useLocation } from "react-router-dom";
import { ApolloWrapper } from "../ApolloWrapper/ApolloWrapper";
import { DEFAULT_FILTER_VALUES } from "../PlaceBidModal/PlaceBidModal";
import { useLazyQuery } from "@apollo/client";
import { GIGS_QUERY } from "../PlaceBidModal/gigsQuery";
import { useDispatch, useSelector } from "react-redux";
import {
  addBatchMatches,
  fetchMyGigsKeySearchSkills,
  getJobListing,
  keySearchMyGigsLocation,
} from "../../redux/actions";
import { getImageByStateCode } from "../../pages/CompanyProfile/components/cloudinary";
import history from "../../routes/history";
import { useWindowDimensions } from "../../hooks/index";
import _ from "lodash";
import MatchedSkillReducer from "./../../redux/reducers/SkillMacthesReducer";

const ChooseGigPage = ({
  handleSelectedGigDetails = () => {},
  backHandler = () => {
    history.goBack();
  },
  ...props
}) => {
  const { width, height } = useWindowDimensions();
  const { state } = useLocation();
  const dispatch = useDispatch();
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const { batchMatchLoading } = useSelector(
    (state) => state.MatchedSkillReducer
  );
  const [getGigs, { loading: loadingGigs, error, data }] =
    useLazyQuery(GIGS_QUERY);
  const [searchFilters, setSearchFilters] = useState({
    DEFAULT_FILTER_VALUES,
  });
  const searchPublish = data?.gigs?.data || [];
  const [selectedGigDetails, setSelectedGigDetails] = useState();
  const [searchText, setSearchText] = useState("");
  const [gigAlert, setGigAlert] = useState(false);
  const [GigType, setGigType] = useState(false);

  const fetchMoreData = (value) => {};

  const updateFilters = (data) => {
    const params = {
      value: "",
      body: {
        isPrivateGig: GigType,
        ...data,
        MygigsProfileId: userProfile?.MasterAccountId || userProfile?.AccountId,
        JobOrderStatusName: "Published",
      },
    };
    dispatch(keySearchMyGigsLocation(params));
    dispatch(fetchMyGigsKeySearchSkills(params));
  };
  const handleSearch = _.debounce((value) => {
    handleApplyFilter({ ...searchFilters, all: value, search: value });
    updateFilters({ ...searchFilters, all: value, search: value });
  }, 600);

  const searchHandler = (seacrhText) => {
    setSearchText(seacrhText);
    handleSearch(seacrhText);
  };
  console.log("location", state);
  console.log("selectedGigDetails", selectedGigDetails);

  const handleApplyFilter = (filters = {}) => {
    try {
      const {
        all,
        cities,
        countries,
        regions,
        Skills,
        explevel,
        isPrivateGig,
        JobOrderTypeName,
        _sort,
      } = filters;
      getGigs({
        variables: {
          all: all || "",
          cities: cities?.length ? cities : undefined,
          countries: countries?.length ? countries : undefined,
          regions: regions?.length ? regions : undefined,
          Skills: Skills?.length ? Skills : undefined,
          isPrivateGig,
          MygigsProfileId:
            userProfile?.MasterAccountId || userProfile?.AccountId,
          SkillListingId: props?.userSKillListing?.skill_listings
            ?.SkillListingId
            ? props?.userSKillListing?.skill_listings?.SkillListingId
            : undefined,
          _page: "1",
          _perPage: 999,
          _sort: _sort || "MOST_RECENT",
          explevel: explevel || undefined,
          JobOrderTypeName: JobOrderTypeName || undefined,
          JobOrderStatusName: "Published",
        },
      });
    } catch (error) {
      console.warn("error", error);
    }
  };

  const addBatchMatch = () => {
    try {
      dispatch(
        addBatchMatches({
          SkillListingIds: state?.skillListingIds,
          GigId: selectedGigDetails?.JobOrderId,
          callBack: successCallBack,
        })
      );
    } catch (error) {}
  };

  const successCallBack = () => {
    localStorage.removeItem("SelectedSkillsSearch");
    backHandler();
  };

  useEffect(() => {
    getGigs({
      variables: {
        all: "",
        isPrivateGig: false,
        MygigsProfileId: userProfile?.MasterAccountId || userProfile?.AccountId,
        _page: "1",
        _perPage: 999,
        _sort: "MOST_RECENT",
        JobOrderStatusName: "Published",
      },
    });
  }, []);

  return (
    <div className="ChooseGig-cantainer-pvt-tal">
      <div className="ChooseGig-Title-pvt">Choose a gig</div>
      <div className="ChooseGig-Section-pvt">
        <Row>
          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            <Input
              className="chooseJobSearch-placeBid"
              style={{
                width: width > 845 && "330px",
                marginLeft: width > 845 && "20px",
              }}
              placeholder="Gig title..."
              value={searchText}
              prefix={<SearchOutlined className="joblisting-searchicon" />}
              onChange={(e) => searchHandler(e.target.value)}
              allowClear
            />
          </Col>
        </Row>
        <AllGigsFilter
          setGigType={setGigType}
          GigType={GigType}
          searchText={searchText}
          handleApplyFilter={handleApplyFilter}
          windowDimensions={{ width, height }}
          searchFilters={searchFilters}
          setSearchFilters={setSearchFilters}
          defaultParams={{ JobOrderStatusName: "Published" }}
          isDropdownClose={true}
        />
        <InfiniteScroll
          dataLength={searchPublish?.length ?? 0}
          next={fetchMoreData}
          hasMore={false}
          scrollableTarget={"infinite-scroll"}
          className={"infinite-scroller-place-bid"}
        >
          <Row>
            {loadingGigs ? (
              <div className="loader-container">
                <LoadingOutlined className="loader" />
              </div>
            ) : searchPublish?.length !== 0 ? (
              searchPublish?.map((item, index) => {
                if (
                  item.JobOrderStatuses?.JobOrderStatusName !== "Deleted" &&
                  item.JobOrderStatuses?.JobOrderStatusName !== "Expired" &&
                  item.JobOrderStatuses?.JobOrderStatusName !== "Closed"
                ) {
                  return (
                    <Col
                      key={index}
                      xs={24}
                      sm={12}
                      md={8}
                      lg={8}
                      xl={8}
                      onClick={() => {
                        if (item.isDisabled) return;
                        handleSelectedGigDetails(item);
                        setSelectedGigDetails(item);
                      }}
                    >
                      <div
                        className={`jobcard-container ${
                          selectedGigDetails?._id === item?._id
                            ? "ChooseGig-selected-card-pvt"
                            : null
                        } ${
                          item.isDisabled ? "jobcard-container-disabled" : null
                        }`}
                      >
                        <JobCard
                          {...item}
                          key={item?.JobOrderId}
                          img={
                            item?.Regions?.Code !== null &&
                            item?.Cities?.CityName !== null
                              ? getImageByStateCode(
                                  item?.Regions?.Code,
                                  item?.Cities?.CityName,
                                  item?.CompanyName
                                )
                              : ""
                          }
                          budgetType={item?.BudgetTypes?.BudgetTypeCode}
                          RegionCode={item?.Regions?.Code}
                          CityName={item?.Cities?.CityName}
                          id={item?.JobOrderId}
                          location={item.Location?.LocationWithCountry}
                          title={item?.Title}
                          facilityname={item?.FacilityName}
                          budget={item?.BudgetMin}
                          rate={item?.BudgetTypes?.BudgetTypeName}
                          cardFooter={false}
                          cardFooterChoose={true}
                          fromDashboard={true}
                          professionCode={
                            props.professionCode?.Professions?.ProfessionCode
                          }
                          rating={item?.facilityRating?.rating}
                          WorkplacePolicy={item?.WorkplacePolicy}
                          created={item?.Created}
                          matchedbids={item?.status?.[2]?.count}
                          placedbids={item?.status?.[0]?.count}
                          receivedbids={item?.status?.[1]?.count}
                          isPrivate={item?.isPrivate}
                        />
                      </div>
                    </Col>
                  );
                }
              })
            ) : (
              <div className="emptyOtherSearch">
                <div className="employer-profile-body">
                  <div
                    className="employer-profile-body-content"
                    style={{ margin: "10px" }}
                  >
                    <img className="nojobimage" src={props.noJobs} />
                    <div className="nojobtext">
                      Create a gig to let candidates know you're hiring!
                    </div>
                    <button
                      className="postajob-btn"
                      onClick={() => history.push("/postjob")}
                    >
                      <span className="postjobbtn_plussign">+</span>
                      <span className="postjobbtn_text">Post a gig</span>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </Row>
        </InfiniteScroll>
      </div>
      <div className="ChooseGigsButton-btn">
        <ChooseGigsButton
          nextHandler={addBatchMatch}
          backHandler={backHandler}
          selectedGigDetails={selectedGigDetails}
          nextButton="Add to matches"
          nextLoading={batchMatchLoading}
        />
      </div>
    </div>
  );
};

const WrappedChooseGigPage = (props) => (
  <ApolloWrapper>
    <ChooseGigPage {...props} />
  </ApolloWrapper>
);
export default WrappedChooseGigPage;
